export * from './admin/admin.component';
export * from './user-management/user-management.component';
